import { useEffect } from "react";
import Lenis from "lenis";

export const SmoothScroll = () => {
  useEffect(() => {
    const lenis = new Lenis({ autoRaf: true, duration: 1.15, smoothWheel: true });
    window.__lenis = lenis;
    const offset = () => -((document.querySelector('[data-testid="site-header"]')?.offsetHeight ?? 72) + 12);
    const onClick = (e) => {
      const a = e.target.closest?.('a[href^="#"]');
      if (!a) return;
      const id = a.getAttribute("href");
      const el = id.length > 1 ? document.querySelector(id) : null;
      if (!el) return;
      e.preventDefault();
      lenis.scrollTo(el, { offset: offset() });
      window.history.replaceState(null, "", id);
      window.dispatchEvent(new HashChangeEvent("hashchange"));
    };
    document.addEventListener("click", onClick);
    if (window.location.hash) {
      const el = document.querySelector(window.location.hash);
      if (el) setTimeout(() => lenis.scrollTo(el, { offset: offset(), immediate: true }), 300);
    }
    return () => {
      document.removeEventListener("click", onClick);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);
  return null;
};
